const PhoneIcon = '/assets/santajuana/General/BusesSaoPaulo-Website-Header-PhoneIcon.svg';
const PopupIcon = '/assets/santajuana/about/aboutus.jpg';

const BookingActive = '/assets/santajuana/Home/buy-ticket.svg';
const CancelActive = '/assets/santajuana/Home/cancel-ticket.svg';
const ChangeTicket = '/assets/santajuana/Home/Searchbar-Change ticket-icon.svg';
const ChangeTicketInactive = '/assets/santajuana/Home/Searchbar-Change ticket-icon.svg';



const BookingInActive = '/assets/santajuana/Home/buy-ticket.svg';
const CancelInActive = '/assets/santajuana/Home/cancel-ticket.svg';

const CuponeraActive = '/assets/santajuana/Home/cuponera.svg';
const CuponeraInactive = '/assets/santajuana/Home/cuponera.svg';

const ConfirmCuponeraActive =
	'/assets/santajuana/Home/confirm-cuponera.svg';
const ConfirmCuponeraInActive =
	'/assets/santajuana/Home/confirm-cuponera.svg';


const OriginIcon = '/assets/santajuana/General/origin.png';
const DestinationIcon =
	'/assets/santajuana/General/destination.svg';
const CalendarIcon = '/assets/santajuana/General/calendar.png';
const pnr = '/assets/santajuana/General/pnr.svg';
// const SearchIcon = '/assets/santajuana/Home/SearchBar-SearchIcon.svg'
// Title icons

// const titleLeftIcon = '/assets/santajuana/General/BusesSaoPaulo-Website-Titles-Icon1.svg';
// const titleRightIcon = '/assets/santajuana/General/BusesSaoPaulo-Website-Titles-Icon2.svg';

const ContactBg = '/assets/santajuana/Home/Imagen contacto+texto-03.webp';

// footerIcons

const fb = '/assets/santajuana/General/BusesSaoPaulo-Website-Footer-SocialMedia-Facebook.svg';
const insta = '/assets/santajuana/General/BusesSaoPaulo-Website-Footer-SocialMedia-Instagram.svg';
const whatsapp = '/assets/santajuana/General/Whatsapp-icon.svg';

const contactFb = '/assets/santajuana/General/facebook.svg';
const contactInsta = '/assets/santajuana/General/instagram.svg';

// banners
const destinationBanner = '/assets/santajuana/Destinations/BusesSaoPaulo-Website-Destinations-Banner.jpg';
const contactUsBanner = '/assets/santajuana/Contact/TransportesSantaJuana-Website-Contact-Banner.webp';
const aboutUsBanner = '/assets/santajuana/about-us/TransportesSantaJuana-Website-Thecompany-Banner.webp';
const tncBanner = '/assets/santajuana/tnc/BusesSaoPaulo-Website-TermsAndConditions-Banner.jpg';
const officeBanner = '/assets/santajuana/Offices/Oficinas-banner.webp';

// const aboutUsSecondBanner =
//   '/assets/santajuana/about-us/BusesSaoPaulo-Website-TheCompany-BannerHistory.jpg';

const aboutUsImage = '/assets/santajuana/about-us/TransportesSantaJuana-Website-TheCompany-Banner bus.webp';

const contactMail = '/assets/santajuana/Contact/Correo-icon.svg';
const contactHeadphone = '/assets/santajuana/Contact/Contacto-icon.svg';
const petseatref = '/static/images/seats/SanAndres-ResultPage-PetsOnBoard-Ammenity.svg';
const pin = '/assets/santajuana/Offices/pin-icon.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const trabajaBanner = '/assets/santajuana/trabaja/Trabaja-con-nosotros-Banner_Banner.webp';
const success = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/santajuana/orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/santajuana/orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/santajuana/orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/santajuana/orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/santajuana/orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/santajuana/orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/santajuana/orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';
const operatorPay = '/assets/santajuana/santajaunapay.jpeg'


const santajuanaIcons = [
	{ icon: operatorPay, name: 'operatorPay' },

	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },
	{ icon: CuponeraActive, name: 'CUA' },
	{ icon: CuponeraInactive, name: 'CUIA' },

	{ icon: ConfirmCuponeraActive, name: 'CCA' },
	{ icon: ConfirmCuponeraInActive, name: 'CCIA' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: PopupIcon, name: 'Popup' },
	{ icon: PhoneIcon, name: 'phone' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: ChangeTicket, name: 'CTA' },
	{ icon: ChangeTicketInactive, name: 'CTIA' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	// { icon: pnr, name: 'pnr' },

	// Title icons
	// { icon: titleLeftIcon, name: 'titleLeftIcon' },
	// { icon: titleRightIcon, name: 'titleRightIcon' },

	{ icon: ContactBg, name: 'ContactBg' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	// footerIcons
	{ icon: fb, name: 'fb' },
	{ icon: insta, name: 'insta' },

	{ icon: contactFb, name: 'contactFb' },
	{ icon: contactInsta, name: 'contactInsta' },

	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	// { icon: aboutUsSecondBanner, name: 'aboutUsSecondBanner' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: contactHeadphone, name: 'contactHeadphone' },

	{ icon: aboutUsImage, name: 'aboutUsImage' },

	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: animation, name: 'animation' },
	// { icon: pnr, name: 'pnr' },
	{ icon: pin, name: 'pin' },
	{ icon: trabajaBanner, name: 'TrabajaBanner' },
	{ icon: whatsapp, name: 'whatsapp' },
	{ icon: petseatref, name: 'petseatref' },
];

export default santajuanaIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/santajuanaIcons.js